import { HttpContext, HttpContextToken } from '@angular/common/http';

/** When true, errorInterceptor won't show its generic toast for this request. */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/** Pass as `context` to opt a request out of the generic error toast, e.g. when
 *  the caller already renders a dedicated error state for it. */
export function skipErrorToast(): HttpContext {
  return new HttpContext().set(SKIP_ERROR_TOAST, true);
}
